import {
  siApplemusic,
  siAudiomack,
  siBandcamp,
  siBeatport,
  siDeezer,
  siIheartradio,
  siItunes,
  siKuaishou,
  siMeta,
  siMixcloud,
  siNapster,
  siNeteasecloudmusic,
  siPandora,
  siPeloton,
  siQq,
  siShazam,
  siSnapchat,
  siSoundcloud,
  siSpotify,
  siTidal,
  siTiktok,
  siYoutube,
  siYoutubemusic,
} from 'simple-icons';
import { c } from '../../styles/theme';
import type { PublisherReleasePlatform } from '../../types/domain';

export interface PublisherOutletGlyphsProps {
  platforms: readonly PublisherReleasePlatform[];
  ariaLabel?: string;
  size?: number;
}

type SimpleIconShape = {
  path: string;
  hex: string;
  title: string;
};

type OutletIconEntry = {
  icon: SimpleIconShape | undefined;
  color?: string;
};

const AMAZON_MUSIC_ICON: SimpleIconShape = {
  title: 'Amazon Music',
  hex: '46C3D0',
  path: 'M14.8454 9.4083c-1.3907 1.0194-3.405 1.563-5.1424 1.563a9.333 9.333 0 0 1-6.2768-2.3835c-.1313-.117-.0143-.277.1415-.1846a12.693 12.693 0 0 0 6.285 1.6574c1.5384 0 3.2348-.318 4.7917-.9764.2359-.0985.4328.1538.203.324h-.002zm.5784-.6564c-.1784-.2257-1.1753-.1087-1.6225-.0554-.1374.0164-.158-.1026-.0349-.1867.796-.5558 2.0984-.3958 2.2502-.2092.1539.1867-.041 1.4872-.7856 2.1087-.1149.0964-.2236.0451-.1723-.082.1682-.4165.5436-1.3498.3651-1.5754zm-1.5917-4.1702v-.5394c0-.082.0615-.1375.1374-.1375h2.4348c.078 0 .1395.0554.1395.1354v.4636c0 .078-.0656.1805-.1846.3405L15.0997 6.635c.4677-.0102.9641.0595 1.3887.2974.0964.0534.123.1334.1292.2113v.5744c0 .082-.0882.1723-.1784.123a2.8163 2.8163 0 0 0-2.5723.0062c-.0861.0451-.1743-.0451-.1743-.1251v-.5477c0-.0882.002-.238.0902-.3713l1.4626-2.0881h-1.2718c-.078 0-.1415-.0534-.1436-.1354l.002.002zm4.808-.7466c1.0995 0 1.6944.9395 1.6944 2.1333 0 1.1528-.6564 2.0676-1.6943 2.0676-1.079 0-1.6656-.9395-1.6656-2.1087 0-1.1774.5948-2.0922 1.6656-2.0922zm.0062.7713c-.5456 0-.5805.7384-.5805 1.202 0 .4615-.0061 1.4481.5744 1.4481.5743 0 .601-.7958.601-1.282 0-.318-.0144-.6994-.1108-1.001-.082-.2625-.2482-.3671-.4841-.3671zm-6.008 3.3414c-.0493.041-.1395.0451-.1744.0164-.2543-.1949-.4246-.4923-.4246-.4923-.4061.4123-.6954.5374-1.2225.5374-.6215 0-1.1077-.3835-1.1077-1.1486a1.2512 1.2512 0 0 1 .7897-1.2041c.402-.1764.9641-.2072 1.3928-.2564 0 0 .0349-.4615-.0902-.6297a.521.521 0 0 0-.4164-.1908c-.2728 0-.5395.1477-.5928.4328-.0144.082-.0739.1518-.1395.1436L9.945 5.08a.1292.1292 0 0 1-.1108-.1537c.1641-.8657.9498-1.1282 1.6554-1.1282.361 0 .8307.0964 1.1158.3671.359.3344.3262.7795.3262 1.2677v1.1487c0 .3446.1436.4964.279.681.0471.0677.0574.1477-.002.197-.1519.125-.5703.4881-.5703.4881zm-.7467-1.7969v-.16c-.5353 0-1.1015.115-1.1015.7426 0 .318.1662.5333.4513.5333.2051 0 .3938-.1272.5128-.3344.1436-.2564.1374-.4943.1374-.7815zM2.9278 7.948c-.0472.041-.1375.045-.1723.0163-.2544-.1949-.4246-.4923-.4246-.4923-.4082.4123-.6954.5374-1.2226.5374-.6235 0-1.1076-.3835-1.1076-1.1486a1.2512 1.2512 0 0 1 .7897-1.2041c.402-.1764.964-.2072 1.3928-.2564 0 0 .0348-.4615-.0903-.6297a.521.521 0 0 0-.4164-.1908c-.2748 0-.5395.1477-.5928.4328-.0143.082-.0759.1518-.1395.1436L.2345 5.08a.1292.1292 0 0 1-.1087-.1537c.162-.8657.9497-1.1282 1.6553-1.1282.361 0 .8308.0964 1.1159.3671.359.3344.324.7795.324 1.2677v1.1487c0 .3446.1437.4964.279.681.0472.0677.0575.1477-.002.197-.1518.125-.5702.4881-.5702.4881zm-.7446-1.797v-.16c-.5354 0-1.1015.115-1.1015.7426 0 .318.164.5333.4512.5333.2052 0 .3939-.1272.5128-.3344.1436-.2564.1375-.4943.1375-.7815zm2.9127-.3343v2.002a.1379.1379 0 0 1-.1395.1374H4.218a.1374.1374 0 0 1-.1395-.1374v-3.766a.1379.1379 0 0 1 .1395-.1375h.6913a.1374.1374 0 0 1 .1374.1374v.482h.0143c.1805-.4758.519-.6994.9744-.6994.4636 0 .7528.2236.962.6995a1.0523 1.0523 0 0 1 1.0215-.6995c.3118 0 .6502.1272.8574.4143.236.318.1867.7795.1867 1.1857v2.3855c0 .076-.0636.1354-.1436.1354H8.181a.1374.1374 0 0 1-.1334-.1354v-2.004c0-.16.0144-.558-.0205-.7077-.0554-.2564-.2215-.3282-.4369-.3282a.4923.4923 0 0 0-.441.3118c-.076.1908-.0698.5087-.0698.724v2.0041c0 .076-.0635.1354-.1435.1354h-.7385a.1374.1374 0 0 1-.1333-.1354v-2.004c0-.4226.0677-1.042-.4574-1.042-.5334 0-.5128.603-.5128 1.042h.002zm16.8077 2.002a.1374.1374 0 0 1-.1374.1374h-.7405a.1374.1374 0 0 1-.1374-.1374v-3.766a.1374.1374 0 0 1 .1374-.1375h.683c.0821 0 .1087.0431.1272.1374v.5764h.0143c.1744-.4616.4964-.679.9559-.679.4718 0 .7446.2174.9579.679.1867-.4616.6113-.679.9559-.679.2461 0 .5169.1025.681.3343.1887.2585.1518.6318.1518.9599l-.0021 2.447c0 .076-.0636.1374-.1395.1374h-.7385a.1374.1374 0 0 1-.1374-.1374v-2.057c0-.1621.0143-.564-.0206-.7159-.0554-.2585-.2215-.3323-.4389-.3323a.4943.4943 0 0 0-.441.3159c-.076.1928-.0698.5128-.0698.7321v2.0572a.1374.1374 0 0 1-.1395.1374h-.7385a.1374.1374 0 0 1-.1374-.1374l-.0021-2.0571c0-.4308.0718-1.0708-.4615-1.0708-.5395 0-.5189.6174-.5189 1.0708v2.0571a.1374.1374 0 0 1-.1395.1374h-.7384z',
};

const OUTLET_ICONS: Readonly<Record<string, OutletIconEntry>> = {
  spotify: { icon: siSpotify },
  'apple-music': { icon: siApplemusic },
  'amazon-music': { icon: AMAZON_MUSIC_ICON },
  'amazon-downloads': { icon: AMAZON_MUSIC_ICON },
  tidal: { icon: siTidal, color: c.text1 },
  deezer: { icon: siDeezer },
  'youtube-music': { icon: siYoutubemusic },
  tiktok: { icon: siTiktok },
  'tiktok-capcut': { icon: siTiktok },
  meta: { icon: siMeta },
  'youtube-content-id': { icon: siYoutube },
  snapchat: { icon: siSnapchat },
  pandora: { icon: siPandora, color: c.text1 },
  soundcloud: { icon: siSoundcloud },
  napster: { icon: siNapster },
  audiomack: { icon: siAudiomack },
  kuaishou: { icon: siKuaishou },
  'netease-cloud-music': { icon: siNeteasecloudmusic },
  'qq-music': { icon: siQq },
  beatport: { icon: siBeatport },
  mixcloud: { icon: siMixcloud },
  'itunes-store': { icon: siItunes },
  bandcamp: { icon: siBandcamp },
  iheartradio: { icon: siIheartradio },
  shazam: { icon: siShazam },
  peloton: { icon: siPeloton },
};

function outletGlyphLabel(outletName: string): string {
  const words = outletName
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (words.length === 0) return '?';
  if (words.length === 1) return words[0].slice(0, 1).toUpperCase();
  return words
    .slice(0, 2)
    .map((word) => word.slice(0, 1).toUpperCase())
    .join('');
}

export function PublisherOutletIcon({
  outletKey,
  outletName,
  size = 20,
}: {
  outletKey: string;
  outletName: string;
  size?: number;
}) {
  const entry = OUTLET_ICONS[outletKey];
  const iconSize = Math.max(12, size);

  return (
    <span
      aria-hidden="true"
      title={outletName}
      style={{
        width: iconSize,
        height: iconSize,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        lineHeight: 1,
        flexShrink: 0,
      }}
    >
      {entry?.icon ? (
        <svg
          viewBox="0 0 24 24"
          width={iconSize}
          height={iconSize}
          focusable="false"
          fill={entry.color ?? `#${entry.icon.hex}`}
        >
          <path d={entry.icon.path} />
        </svg>
      ) : (
        <span
          style={{
            color: c.text2,
            fontSize: size <= 18 ? 9 : 10,
            fontWeight: 600,
            letterSpacing: 0,
          }}
        >
          {outletGlyphLabel(outletName)}
        </span>
      )}
    </span>
  );
}

function uniquePlatforms(platforms: readonly PublisherReleasePlatform[]): PublisherReleasePlatform[] {
  const seen = new Set<string>();
  return [...platforms]
    .filter((platform) => {
      if (seen.has(platform.outletKey)) return false;
      seen.add(platform.outletKey);
      return true;
    })
    .sort((a, b) => a.outletName.localeCompare(b.outletName));
}

export default function PublisherOutletGlyphs({
  platforms,
  ariaLabel,
  size = 20,
}: PublisherOutletGlyphsProps) {
  const items = uniquePlatforms(platforms);
  if (items.length === 0) return null;

  const label = ariaLabel ?? `Reported outlets: ${items.map((platform) => platform.outletName).join(', ')}`;
  return (
    <span
      role="img"
      aria-label={label}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        flexWrap: 'wrap',
      }}
    >
      {items.map((platform) => {
        return (
          <span
            key={platform.outletKey}
            aria-hidden="true"
            title={platform.outletName}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              lineHeight: 1,
              flexShrink: 0,
            }}
          >
            <PublisherOutletIcon
              outletKey={platform.outletKey}
              outletName={platform.outletName}
              size={size}
            />
          </span>
        );
      })}
    </span>
  );
}
